import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-179be5e8")

_pushScopeId("data-v-179be5e8")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title" }, "👋 Congratulation!", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "You are now a part of the Cohackers community!", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("strong", null, "EXPLORE COHACKERS", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "background-confetti",
      style: {
      background: `url(${_ctx.BACKGROUND_CONFETTI}) 0% 0%  ${
        _ctx.windowWidth < 769 ? '' : '/ 100% 100% '
      }`
    }
    }, null, 4),
    _createVNode("div", {
      class: 
      `container box custom-box shadow content-center text-center ${
        _ctx.windowWidth < 769 ? 'box-mobile' : 'box-desktop'
      }`
    
    }, [
      _hoisted_1,
      _hoisted_2,
      _createVNode("button", {
        class: `button margin-t-24 green-button ${_ctx.isLoading}`,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args))),
        disabled: _ctx.isDisabled || _ctx.loading
      }, [
        _hoisted_3
      ], 10, ["disabled"])
    ], 2)
  ], 64))
})